// extracted by mini-css-extract-plugin
export default {"dropdown__empty":"DropdownEmpty_dropdown__empty__FTBZH"};